module.exports = __webpack_public_path__ + "static/media/tick.db5d5e55.svg";